import { render } from "./orderWelcomeCard.vue?vue&type=template&id=4bff255e"
import script from "./orderWelcomeCard.vue?vue&type=script&lang=js"
export * from "./orderWelcomeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__